import angular from 'angular';
import { sqCompositeSearchActions } from '@/hybrid/tools/compositeSearch/compositeSearch.actions';

angular.module('Sq.TrendData').service('sqCompositeSearchActions', sqCompositeSearchActions);
